export default __webpack_public_path__ + "static/34-d493e10e8677e124cebaf502433a02f8.png";